import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import SydButton from '../../../../../commonDesign/Button'

const useStyles = makeStyles(() => ({
  root: {
    border: 'var(--border-neutral-thin)',
    background: 'var(--surface-bg-color-d1)'
  },
  codeWrapper: {
    maxHeight: 300
  }
}))

function CodeBlock ({ language, code }) {
  const classes = useStyles()

  return (
    <div className={`${classes.root} radius-md overflow-hidden`}>
      <div
        className='flex justify-between items-center py-1 px-2'
        style={{ borderBottom: 'var(--border-neutral-thin)' }}
      >
        <span className='font-size-xs opacity-lowlighted'>{language || 'text'}</span>
        <div className='flex gap-xs'>
          <SydButton size='xs' variant='secondary' onClick={() => navigator.clipboard.writeText(code)}>
            Copy
          </SydButton>
        </div>
      </div>
      <div className={`${classes.codeWrapper} overflow-auto`}>
        <pre className='m-0 p-2 font-size-xs'>
          <code>{code}</code>
        </pre>
      </div>
    </div>
  )
}

CodeBlock.propTypes = {
  language: PropTypes.string,
  code: PropTypes.string.isRequired
}

export default CodeBlock
